import React from "react";
import { Main } from "./styled"

const Container = ({ children }) => (
    <Main>
        {children}
    </Main>
);

export default Container;